// 合同编号
export const contractRe = /^[0-9a-zA-Z-]*$/;

// 有效时间
export const dateRe = /^([3-9]|[1-2][0-9]?|30)$/;
